(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (
    !configuratorRoot ||
    configuratorRoot.configuratorDesignRecipes ||
    !configuratorRoot.configuratorLayouts ||
    !configuratorRoot.configuratorDesignDocuments ||
    !configuratorRoot.configuratorProfessionalTemplates
  ) return;

  var layouts = configuratorRoot.configuratorLayouts;
  var documents = configuratorRoot.configuratorDesignDocuments;
  var professionalTemplates = configuratorRoot.configuratorProfessionalTemplates;
  var WIDTH = layouts.artworkSize.width;
  var HEIGHT = layouts.artworkSize.height;
  var SAFE = layouts.safeArea;
  var RECIPE_VERSION = 6;
  var palettes = {
    classic: { background: '#fbfaf6', text: '#24211e', accent: '#8b4033', family: 'Georgia, serif', detailFamily: 'Courier New, monospace' },
    modern: { background: '#ffffff', text: '#202624', accent: '#202624', family: 'Times New Roman, serif', detailFamily: 'Arial, sans-serif' },
    simple: { background: '#fffefa', text: '#202624', accent: '#202624', family: 'Georgia, serif', detailFamily: 'Arial, sans-serif' },
    neutral: { background: '#ffffff', text: '#000000', accent: '#000000', family: 'Georgia, serif', detailFamily: 'Arial, sans-serif' }
  };
  var recipes = [
    {
      id: 'create-my-own',
      label: 'Create my own design',
      description: 'Begin with your content in a neutral, editable starting design.',
      build: buildCreateMyOwn
    },
    {
      id: 'classic',
      label: 'Classic',
      description: 'A poised identity-and-contact composition inspired by traditional hospitality sleeves.',
      build: buildProfessional
    },
    {
      id: 'modern',
      label: 'Modern',
      description: 'A centered identity with crisp supporting information on the reverse.',
      build: buildProfessional
    },
    {
      id: 'simple',
      label: 'Simple',
      description: 'Generous whitespace keeps your restaurant identity clear and memorable.',
      build: buildProfessional
    },
    {
      id: 'bold',
      label: 'Bold',
      description: 'A confident color field and oversized typography create immediate presence.',
      build: buildProfessional
    },
    {
      id: 'traditional',
      label: 'Traditional',
      description: 'An asymmetric, quietly detailed treatment with a composed two-sided balance.',
      build: buildProfessional
    },
    {
      id: 'text',
      label: 'Text',
      description: 'A structured typographic system gives detailed restaurant content room to work.',
      build: buildProfessional
    },
    {
      id: 'instructional',
      label: 'Instructional',
      description: 'A message-led direction that organizes guest instructions with strong visual rhythm.',
      build: buildProfessional
    },
    {
      id: 'locational',
      label: 'Locational',
      description: 'Restaurant identity leads while address and contact details form a clear information row.',
      build: buildProfessional
    }
  ];
  var compatibilityRecipes = {
    signature: buildClassic,
    'clean-line': buildModern,
    'warm-welcome': buildSimple
  };

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function enabledModules(configuration) {
    return layouts.moduleOrder.filter(function (moduleId) {
      return configuration.content.enabledTypes.indexOf(moduleId) !== -1;
    });
  }

  function frameInSafeArea(x, y, width, height) {
    return {
      x: (SAFE.x + SAFE.width * x) / WIDTH,
      y: (SAFE.y + SAFE.height * y) / HEIGHT,
      width: SAFE.width * width / WIDTH,
      height: SAFE.height * height / HEIGHT
    };
  }

  function semanticItem(moduleId, reference, role, weight, type) {
    return {
      module: moduleId,
      reference: reference,
      role: role,
      weight: weight,
      type: type || 'text'
    };
  }

  function semanticItems(configuration) {
    var active = enabledModules(configuration);
    var values = configuration.content.values;
    var items = [];
    function hasValue(value) { return Boolean(String(value || '').trim()); }
    if (active.indexOf('logo') !== -1 && configuration.logo) {
      items.push(semanticItem('logo', 'logo', 'brand', logoWeight(configuration), 'image'));
    }
    if (active.indexOf('restaurantName') !== -1 && hasValue(values.restaurantName)) {
      items.push(semanticItem('restaurantName', 'restaurantName', 'title', 1.5));
    }
    if (active.indexOf('restaurantInfo') !== -1) {
      if (hasValue(values.restaurantInfo.address)) {
        items.push(semanticItem('restaurantInfo', 'restaurantInfo.address', 'details', 1.35));
      }
      if (hasValue(values.restaurantInfo.phone)) {
        items.push(semanticItem('restaurantInfo', 'restaurantInfo.phone', 'details', .9));
      }
      if (hasValue(values.restaurantInfo.contact)) {
        items.push(semanticItem('restaurantInfo', 'restaurantInfo.contact', 'details', 1.15));
      }
    }
    if (active.indexOf('message') !== -1 && hasValue(values.message)) {
      items.push(semanticItem('message', 'message', 'message', 1.85));
    }
    if (active.indexOf('additionalText') !== -1 && hasValue(values.additionalText)) {
      items.push(semanticItem('additionalText', 'additionalText', 'additional', 1.05));
    }
    return items;
  }

  function logoWeight(configuration) {
    var logo = configuration.logo;
    if (!logo || !logo.width || !logo.height) return 1.35;
    var aspect = logo.width / logo.height;
    if (aspect < .85) return 1.05;
    if (aspect > 3) return 1.75;
    return 1.35;
  }

  function selectItems(items, predicate) {
    return items.filter(predicate);
  }

  function withoutItems(items, excluded) {
    return items.filter(function (item) { return excluded.indexOf(item) === -1; });
  }

  function brandItems(items) {
    return selectItems(items, function (item) {
      return item.module === 'logo' || item.module === 'restaurantName';
    });
  }

  function informationItems(items) {
    return selectItems(items, function (item) { return item.module === 'restaurantInfo'; });
  }

  function narrativeItems(items) {
    return selectItems(items, function (item) {
      return item.module === 'message' || item.module === 'additionalText';
    });
  }

  function paletteFor(recipeId) {
    return palettes[recipeId] || palettes.neutral;
  }

  function textStyle(item, frame, recipeId, options) {
    options = options || {};
    var palette = paletteFor(recipeId);
    var maximum = item.role === 'title' ? 50 : item.role === 'message' ? 32 : item.role === 'additional' ? 27 : 23;
    if (recipeId === 'bold' && item.role === 'title') maximum = 58;
    if (recipeId === 'simple' && item.role === 'title') maximum = 46;
    if (recipeId === 'text' && item.role === 'details') maximum = 22;
    var family = item.role === 'title' || item.role === 'message' ? palette.family : palette.detailFamily;
    var weight = item.role === 'title' ? 700 : item.role === 'message' ? 500 : item.role === 'additional' ? 600 : 500;
    if (recipeId === 'modern' && item.role === 'title') weight = 400;
    if (recipeId === 'traditional' && item.role === 'title') weight = 600;
    return {
      fontFamily: family,
      fontWeight: weight,
      fontStyle: options.italic || (item.role === 'message' && recipeId === 'classic') ? 'italic' : 'normal',
      fontSize: Math.min(maximum / HEIGHT, frame.height * .78),
      lineHeight: options.lineHeight || 1.12,
      fill: options.fill || palette.text,
      align: options.align || 'center',
      fit: 'shrink',
      paddingX: (options.paddingX === undefined ? 7 : options.paddingX) / WIDTH,
      paddingY: (options.paddingY === undefined ? 2 : options.paddingY) / HEIGHT
    };
  }

  function objectId(recipeId, side, item, index) {
    return 'recipe-' + recipeId + '-' + side + '-' + item.reference.replace(/[^a-zA-Z0-9]+/g, '-') + '-' + index;
  }

  function objectFor(recipeId, side, item, frame, index, options) {
    options = options || {};
    if (item.type === 'image') {
      return {
        id: objectId(recipeId, side, item, index),
        type: 'image',
        role: item.role,
        frame: clone(frame),
        rotation: options.rotation || 0,
        assetRef: { kind: 'semantic', reference: 'logo' },
        style: {
          fit: 'contain',
          align: options.align || 'center',
          padding: options.imagePadding === undefined ? .07 : options.imagePadding,
          opacity: 1
        }
      };
    }
    return {
      id: objectId(recipeId, side, item, index),
      type: 'text',
      role: item.role,
      frame: clone(frame),
      rotation: options.rotation || 0,
      content: { kind: 'semantic', reference: item.reference },
      style: textStyle(item, frame, recipeId, options)
    };
  }

  function semanticTextValue(reference, configuration) {
    var values = configuration.content.values;
    if (reference === 'restaurantInfo') {
      return [values.restaurantInfo.address, values.restaurantInfo.phone, values.restaurantInfo.contact]
        .map(function (value) { return String(value || '').trim(); })
        .filter(Boolean)
        .join('  •  ');
    }
    if (reference.indexOf('restaurantInfo.') === 0) {
      return String(values.restaurantInfo[reference.split('.')[1]] || '').trim();
    }
    return String(values[reference] || '').trim();
  }

  function centeredFrame(frame, width, height) {
    var centerX = frame.x + frame.width / 2;
    var centerY = frame.y + frame.height / 2;
    return {
      x: centerX - width / WIDTH / 2,
      y: centerY - height / HEIGHT / 2,
      width: width / WIDTH,
      height: height / HEIGHT
    };
  }

  function compactTextFrame(object, configuration) {
    var text = semanticTextValue(object.content.reference, configuration);
    if (!text) return object.frame;
    var probe = clone(object);
    probe.text = text;
    probe.style.fit = 'fixed';
    probe.style.wrap = 'none';
    var measurement = layouts.measureTextObject(probe);
    var paddingX = probe.style.paddingX * WIDTH;
    var paddingY = probe.style.paddingY * HEIGHT;
    var width = Math.max(24, measurement.textWidth + Math.max(8, paddingX * 2));
    var height = Math.max(16, measurement.textHeight + Math.max(6, paddingY * 2));
    return centeredFrame(object.frame, width, height);
  }

  function compactImageFrame(object, configuration) {
    var logo = configuration.logo;
    if (!logo || !logo.width || !logo.height) return object.frame;
    var rectangle = {
      width: object.frame.width * WIDTH,
      height: object.frame.height * HEIGHT
    };
    var padding = Math.min(10, rectangle.height * object.style.padding);
    var availableWidth = Math.max(1, rectangle.width - padding * 2);
    var availableHeight = Math.max(1, rectangle.height - padding * 2);
    var scale = Math.min(availableWidth / logo.width, availableHeight / logo.height);
    var width = logo.width * scale + padding * 2;
    var height = logo.height * scale + padding * 2;
    return centeredFrame(object.frame, Math.max(24, width), Math.max(16, height));
  }

  function compactGeneratedDocument(document, configuration) {
    if (!document || document.provenance.kind === 'professional-template') return document;
    var compacted = clone(document);
    ['front', 'back'].forEach(function (side) {
      compacted.sides[side].objects.forEach(function (object) {
        if (object.type === 'text' && object.content.kind === 'semantic') {
          object.frame = compactTextFrame(object, configuration);
          object.style.fit = 'fixed';
          object.style.autoGrow = true;
        } else if (object.type === 'image' && object.assetRef.kind === 'semantic') {
          object.frame = compactImageFrame(object, configuration);
        }
      });
    });
    return documents.createDocument({ provenance: compacted.provenance, sides: compacted.sides });
  }

  function sameFrame(first, second) {
    return ['x', 'y', 'width', 'height'].every(function (key) {
      return Math.abs(first[key] - second[key]) < .000001;
    });
  }

  function placeRow(recipeId, side, items, area, options) {
    if (!items.length) return [];
    options = options || {};
    var gap = items.length > 1 ? (options.gap === undefined ? .018 : options.gap) : 0;
    var available = area.width - gap * (items.length - 1);
    var totalWeight = items.reduce(function (total, item) {
      return total + (options.equal ? 1 : item.weight);
    }, 0);
    var cursor = area.x;
    return items.map(function (item, index) {
      var weight = options.equal ? 1 : item.weight;
      var width = index === items.length - 1 ? area.x + area.width - cursor : available * weight / totalWeight;
      var frame = frameInSafeArea(cursor, area.y, width, area.height);
      cursor += width + gap;
      return objectFor(recipeId, side, item, frame, index, options);
    });
  }

  function placeStack(recipeId, side, items, area, options) {
    if (!items.length) return [];
    options = options || {};
    var gap = items.length > 1 ? (options.gap === undefined ? .05 : options.gap) : 0;
    var available = area.height - gap * (items.length - 1);
    var totalWeight = items.reduce(function (total, item) {
      return total + (item.role === 'title' ? 1.25 : item.role === 'brand' ? 1.3 : 1);
    }, 0);
    var cursor = area.y;
    return items.map(function (item, index) {
      var weight = item.role === 'title' ? 1.25 : item.role === 'brand' ? 1.3 : 1;
      var height = index === items.length - 1 ? area.y + area.height - cursor : available * weight / totalWeight;
      var frame = frameInSafeArea(area.x, cursor, area.width, height);
      cursor += height + gap;
      return objectFor(recipeId, side, item, frame, index, options);
    });
  }

  function side(fill, objects) {
    return { background: { fill: fill }, objects: objects };
  }

  function createRecipeDocument(recipe, front, back, backgrounds) {
    return documents.createDocument({
      provenance: {
        kind: recipe.id === 'create-my-own' ? 'create-my-own' : 'personalized-recipe',
        sourceId: recipe.id,
        sourceVersion: RECIPE_VERSION
      },
      sides: {
        front: side(backgrounds.front, front),
        back: side(backgrounds.back, back)
      }
    });
  }

  function buildProfessional(configuration, recipe) {
    var sides = professionalTemplates.instantiate(recipe.id);
    if (!sides) return null;
    return documents.createDocument({
      provenance: {
        kind: 'professional-template',
        sourceId: recipe.id,
        sourceVersion: RECIPE_VERSION
      },
      sides: sides
    });
  }

  function fallbackSplit(items) {
    var midpoint = Math.max(1, Math.ceil(items.length / 2));
    return { front: items.slice(0, midpoint), back: items.slice(midpoint) };
  }

  function buildClassic(configuration, recipe) {
    var items = semanticItems(configuration, true);
    var brand = brandItems(items);
    var information = informationItems(items);
    var narrative = narrativeItems(items);
    var frontItems = brand.concat(information.filter(function (item) {
      return item.reference === 'restaurantInfo.phone' || item.reference === 'restaurantInfo.contact';
    }));
    var backItems = withoutItems(items, frontItems);
    if (!frontItems.length) {
      var fallback = fallbackSplit(items);
      frontItems = fallback.front;
      backItems = fallback.back;
    }
    if (!backItems.length && narrative.length) backItems = narrative;
    return createRecipeDocument(
      recipe,
      placeRow(recipe.id, 'front', frontItems, { x: .02, y: .06, width: .96, height: .88 }, { align: 'center', gap: .028 }),
      placeRow(recipe.id, 'back', backItems, { x: .06, y: .12, width: .88, height: .76 }, { align: 'center', gap: .035, italic: false }),
      { front: palettes.classic.background, back: palettes.classic.background }
    );
  }

  function buildModern(configuration, recipe) {
    var items = semanticItems(configuration, false);
    var identity = brandItems(items);
    var additional = selectItems(items, function (item) { return item.module === 'additionalText'; });
    var frontItems = identity.concat(additional);
    if (!frontItems.length) frontItems = items.slice(0, 1);
    var backItems = withoutItems(items, frontItems);
    var frontObjects = frontItems.length <= 2
      ? placeStack(recipe.id, 'front', frontItems, { x: .31, y: .03, width: .38, height: .94 }, { align: 'center', gap: .04 })
      : placeRow(recipe.id, 'front', frontItems, { x: .22, y: .08, width: .56, height: .84 }, { align: 'center', gap: .025 });
    return createRecipeDocument(
      recipe,
      frontObjects,
      placeRow(recipe.id, 'back', backItems, { x: .04, y: .1, width: .92, height: .8 }, { align: 'left', gap: .032 }),
      { front: palettes.modern.background, back: palettes.modern.background }
    );
  }

  function buildSimple(configuration, recipe) {
    var items = semanticItems(configuration, false);
    var identity = brandItems(items);
    var frontItems = identity.length ? identity : items.slice(0, 1);
    var backItems = withoutItems(items, frontItems);
    return createRecipeDocument(
      recipe,
      placeRow(recipe.id, 'front', frontItems, { x: .3, y: .12, width: .4, height: .76 }, { align: 'center', gap: .035, imagePadding: .1 }),
      placeRow(recipe.id, 'back', backItems, { x: .24, y: .18, width: .52, height: .64 }, { align: 'center', gap: .045 }),
      { front: palettes.simple.background, back: palettes.simple.background }
    );
  }

  function buildCreateMyOwn(configuration, recipe) {
    var items = semanticItems(configuration, false);
    var logo = items.find(function (item) { return item.module === 'logo'; });
    var logoOnFront = enabledModules(configuration).indexOf('logo') !== -1 && logo;
    var split = logoOnFront
      ? { front: [logo], back: withoutItems(items, [logo]) }
      : fallbackSplit(items);
    return createRecipeDocument(
      recipe,
      placeRow(recipe.id, 'front', split.front, { x: .04, y: .1, width: .92, height: .8 }, { align: logoOnFront ? 'center' : 'left', gap: .032 }),
      placeRow(recipe.id, 'back', split.back, { x: .04, y: .1, width: .92, height: .8 }, { align: 'left', gap: .032 }),
      { front: palettes.neutral.background, back: palettes.neutral.background }
    );
  }

  function recipeById(recipeId) {
    return recipes.find(function (recipe) { return recipe.id === recipeId; }) || null;
  }

  function compatibilityDocument(recipeId, configuration) {
    if (compatibilityRecipes[recipeId]) {
      return compatibilityRecipes[recipeId](configuration, { id: recipeId });
    }
    if (['brand-forward', 'balanced', 'alternate-focus'].indexOf(recipeId) === -1) return null;
    var candidate = layouts.generate(configuration).find(function (item) { return item.id === recipeId; });
    return candidate ? documents.fromComposition(candidate.composition, configuration) : null;
  }

  function instantiate(recipeId, configuration) {
    var recipe = recipeById(recipeId);
    var document = recipe ? recipe.build(configuration, recipe) : compatibilityDocument(recipeId, configuration);
    if (document && recipe) document = compactGeneratedDocument(document, configuration);
    return document && documents.validateDocument(document, configuration) ? document : null;
  }

  function semanticObjectKey(object) {
    if (object.type === 'image' && object.assetRef && object.assetRef.kind === 'semantic') return 'image:' + object.assetRef.reference;
    if (object.type === 'text' && object.content && object.content.kind === 'semantic') return 'text:' + object.content.reference;
    return null;
  }

  function upgradeDocument(document, configuration) {
    if (!document || !document.provenance || document.provenance.sourceVersion >= RECIPE_VERSION) return document;
    if (
      document.provenance.kind !== 'personalized-recipe' &&
      document.provenance.kind !== 'professional-template' &&
      document.provenance.kind !== 'create-my-own'
    ) return document;
    if (document.provenance.kind === 'professional-template') {
      var preservedProvenance = clone(document.provenance);
      preservedProvenance.sourceVersion = RECIPE_VERSION;
      var upgradedProfessional = documents.createDocument({ provenance: preservedProvenance, sides: clone(document.sides) });
      return upgradedProfessional && documents.carryDeletedObjects
        ? documents.carryDeletedObjects(document, upgradedProfessional)
        : upgradedProfessional || document;
    }
    var recipe = recipeById(document.provenance.sourceId);
    var rawPristine = recipe ? recipe.build(configuration, recipe) : compatibilityDocument(document.provenance.sourceId, configuration);
    var pristine = rawPristine && recipe ? compactGeneratedDocument(rawPristine, configuration) : rawPristine;
    if (!pristine) return document;
    var existingByKey = {};
    var rawByKey = {};
    ['front', 'back'].forEach(function (side) {
      rawPristine.sides[side].objects.forEach(function (object) {
        var key = semanticObjectKey(object);
        if (key && !rawByKey[key]) rawByKey[key] = object;
      });
    });
    var customBySide = { front: [], back: [] };
    ['front', 'back'].forEach(function (side) {
      document.sides[side].objects.forEach(function (object) {
        var key = semanticObjectKey(object);
        if (key && key !== 'text:restaurantInfo' && !existingByKey[key]) existingByKey[key] = clone(object);
        else if (!key) customBySide[side].push(clone(object));
      });
    });
    var isProfessional = professionalTemplates.ids.indexOf(document.provenance.sourceId) !== -1;
    var sides = {};
    ['front', 'back'].forEach(function (side) {
      sides[side] = {
        background: clone(isProfessional ? pristine.sides[side].background : document.sides[side].background),
        objects: pristine.sides[side].objects.map(function (object) {
          var existing = existingByKey[semanticObjectKey(object)];
          var raw = rawByKey[semanticObjectKey(object)];
          if (existing && raw && sameFrame(existing.frame, raw.frame)) {
            existing.frame = clone(object.frame);
            if (existing.type === 'text') {
              existing.style.fit = 'fixed';
              existing.style.autoGrow = true;
            }
          }
          if (
            existing && existing.type === 'text' && existing.style &&
            String(existing.style.fill).toLowerCase() === '#173f3a'
          ) existing.style.fill = '#000000';
          return existing || clone(object);
        }).concat(customBySide[side])
      };
    });
    var upgraded = documents.createDocument({ provenance: pristine.provenance, sides: sides });
    return upgraded && documents.carryDeletedObjects
      ? documents.carryDeletedObjects(document, upgraded)
      : upgraded || document;
  }

  function generate(configuration) {
    return recipes.map(function (recipe) {
      return {
        id: recipe.id,
        label: recipe.label,
        description: recipe.description,
        kind: recipe.id === 'create-my-own' ? 'create-my-own' : 'design',
        document: instantiate(recipe.id, configuration)
      };
    }).filter(function (candidate) { return Boolean(candidate.document); });
  }

  configuratorRoot.configuratorDesignRecipes = {
    version: RECIPE_VERSION,
    generate: generate,
    instantiate: instantiate,
    upgradeDocument: upgradeDocument,
    has: function (recipeId) { return Boolean(recipeById(recipeId)); },
    ids: recipes.map(function (recipe) { return recipe.id; })
  };
}());
